import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { RelCreatorDialog } from '@/common/entityFramework/relCreator/RelCreatorDialog';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useState } from 'react';

// Lists the child Products of a Prod Set (PROD_REL rows with relType CAT) and lets the user bulk-add more
export const ProdSetProdRelList = ({ prodSetObj }) => {
  const module = useModuleFromRoute();
  const { openDialog } = useDialog();
  const [refreshKey, setRefreshKey] = useState(0);

  const augRowsReq = (rowsReq) => {
    const addlExpr = ExprUtils.whereParams('parentProdId', prodSetObj.id);
    rowsReq.expr = ExprUtils.and(rowsReq.expr, addlExpr);
  };

  const augFieldDefs = (fieldToFieldDef) => {
    ['parentProdId', 'parentProdCode', 'parentProdName', 'relType', 'polType'].forEach(
      (key) => delete fieldToFieldDef[key],
    );
  };

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    tabButtons.push(<TitleButton icon={fas.faPlus} toolTip="Add Product" onClick={addProds} />);
  };

  const addProds = () => {
    openDialog(RelCreatorDialog, {
      data: {
        module,
        entity: 'PROD',
        parentObj: prodSetObj,
        fieldDefaults: { relType: 'CAT', startDate: 19000101, endDate: 99991231 },
        buildCode: (prodSet, prod) => `${prodSet.code}_SET_${prod.code}`,
        augDialogRowsReq: (rowsReq) => {
          const addlExpr = ExprUtils.fieldExpr('type', 'IS_NOT', 'PROD_SET');
          rowsReq.expr = ExprUtils.and(rowsReq.expr, addlExpr);
        },
      },
    }).then((created) => {
      if (created) setRefreshKey((key) => key + 1);
    });
  };

  return (
    <EntityList
      key={refreshKey}
      module={module}
      entity="PROD_REL"
      augRowsReq={augRowsReq}
      augFieldDefs={augFieldDefs}
      augTabButtons={augTabButtons}
    />
  );
};
